import React from 'react';

import { HN_SKJEMA_FRONTEND_RESOURCES } from 'src/constants/constants';
import { useGetSubmitButtonText } from 'src/hooks/useGetSubmitButtonText';
import { useResources } from 'src/resources';
import { useAppSelector } from 'src/store/reducers';

import type { FieldValues, UseFormReturn } from 'react-hook-form';
import type { HNSkjemaFrontend } from 'src/types/Resources';

import Button from '@helsenorge/designsystem-react/components/Button';
import Icon from '@helsenorge/designsystem-react/components/Icon';
import Save from '@helsenorge/designsystem-react/components/Icons/Save';

interface Props {
  reactHookFormMethods: UseFormReturn<FieldValues, unknown>;
  onCancel: () => void;
  onSubmit: () => void;
  onSave: () => void;
  trackFormError: () => void;
  erSendOgLagreKnapperDisabled: boolean;
  displaySaveIcon: boolean;
}

const FormButtonsStandard = ({
  reactHookFormMethods,
  onCancel,
  onSubmit,
  onSave,
  trackFormError,
  erSendOgLagreKnapperDisabled,
  displaySaveIcon,
}: Props): React.JSX.Element => {
  const resources = useResources<HNSkjemaFrontend>(HN_SKJEMA_FRONTEND_RESOURCES);
  const kanMellomlagres = useAppSelector(state => state.refero.ui.kanMellomlagres);
  const { isMicroweb, showSubmitButton, showSaveButton, showCancelButton } = useAppSelector(state => state.microweb);
  const submitButtonText = useGetSubmitButtonText();
  const showButtonBar = showSubmitButton || showSaveButton || showCancelButton;

  const onSubmitButtonClicked = (): void => {
    const handleSubmit = reactHookFormMethods.handleSubmit(
      () => onSubmit(),
      () => trackFormError()
    );
    handleSubmit();
  };

  return (
    <>
      {!isMicroweb && (
        <div className="formButtonsWrapper formButtonsBackground" data-testid="form-buttons-standard">
          <div className="formButtonInnerWrapper">
            <Button type="submit" disabled={erSendOgLagreKnapperDisabled} onClick={onSubmitButtonClicked} testId="submit-button">
              {submitButtonText}
            </Button>
            {kanMellomlagres && (
              <Button variant="outline" disabled={erSendOgLagreKnapperDisabled} onClick={onSave} testId="save-button">
                {displaySaveIcon && <Icon svgIcon={Save} />}
                {resources?.formSave}
              </Button>
            )}
            <Button variant="borderless" onClick={onCancel} testId="cancel-button">
              {resources?.formCancel}
            </Button>
          </div>
        </div>
      )}
      {isMicroweb && showButtonBar && (
        <div className="formButtonsWrapper formButtonsBackground" data-testid="form-buttons-microweb-standard">
          <div className="formButtonInnerWrapper">
            {showSubmitButton && (
              <Button type="submit" disabled={erSendOgLagreKnapperDisabled} onClick={onSubmitButtonClicked} testId="submit-button">
                {submitButtonText}
              </Button>
            )}
            {showSaveButton && kanMellomlagres && (
              <Button variant="outline" disabled={erSendOgLagreKnapperDisabled} onClick={onSave} testId="save-button">
                {displaySaveIcon && <Icon svgIcon={Save} />}
                {resources?.formSave}
              </Button>
            )}
            {showCancelButton && (
              <Button variant="borderless" onClick={onCancel} testId="cancel-button">
                {resources?.formCancel}
              </Button>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default FormButtonsStandard;
